import React from 'react';
import { ButtonData, ButtonContainer } from '../jsxElements/Button';

import { AmpFlagSet } from '../amplitude';

export type AdaptiveButtonListData = {
    type: string;
    actions?: ButtonData[];
    featureFlags: AmpFlagSet;
};

type AdaptiveButtonListArgs = {
    data: AdaptiveButtonListData;
    disableButtons: boolean;
    featureFlags: AmpFlagSet;
    sendMessage: (message: string) => void;
};

export const AdaptiveButtonList: React.FC<AdaptiveButtonListArgs> = ({
    data,
    disableButtons,
    featureFlags,
    sendMessage,
}: AdaptiveButtonListArgs) => (
    <ButtonContainer
        buttons={
            data.actions?.map((button, index) => ({
                button,
                disableButtons,
                index,
                featureFlags,
                sendMessage,
            })) || []
        }
        featureFlags={featureFlags}
    />
);
